import React from 'react';

import useLocal from 'localization';

import Props from './types';
import { Link } from 'react-router-dom';
import routes from 'components/Router/routes';

const ModelFreeTrierTooltip: React.FC<Props> = ({ showNotAllowed }: Props) => {
  const accessNotAllowed = useLocal('access_not_allowed_trial_user');
  const inquireHere = useLocal('trial_here');
  const reachedMaxSubscription = useLocal('reached_max_subscription_trial_user');

  return (
    <>
      {showNotAllowed ? (
        <>
          {accessNotAllowed} <Link to={routes.INQUIRE_HERE_POPUP}>{inquireHere}</Link>
        </>
      ) : (
        <>
          {reachedMaxSubscription} <Link to={routes.INQUIRE_HERE_POPUP}>{inquireHere}</Link>
        </>
      )}
    </>
  );
};

export default ModelFreeTrierTooltip;
